import { useCallback } from 'react';
import { useFetcher } from 'react-router';

import { useBloomBasename } from '@jane/bloom/hooks/useBloomBasename';
import type { MarketplaceCartPayload } from '@jane/bloom/routes/$basename.api.marketplace.cart/types';
import { buildFormData } from '@jane/bloom/utils/formData';
import type { Cart } from '@jane/bloom/viewModels/cart';

export function useMarketplaceCart() {
  const basename = useBloomBasename();
  const marketplaceCartFetcher = useFetcher<Cart>();

  const createCart = useCallback(
    ({ products, reservationMode, storeId }: MarketplaceCartPayload) => {
      marketplaceCartFetcher.submit(
        buildFormData({
          products: JSON.stringify(products),
          reservationMode,
          storeId,
        }),
        {
          action: `${basename}api/marketplace/cart`,
          method: 'post',
        }
      );
    },
    [basename, marketplaceCartFetcher]
  );

  const deleteCart = useCallback(
    ({ cartUuid }: { cartUuid: string }) => {
      marketplaceCartFetcher.submit(
        buildFormData({
          uuid: cartUuid,
        }),
        {
          action: `${basename}api/marketplace/cart`,
          method: 'delete',
        }
      );
    },
    [basename, marketplaceCartFetcher]
  );

  return {
    createCart,
    deleteCart,
    newCart: marketplaceCartFetcher.data,
  };
}
